import { createBrowserRouter } from 'react-router';
import { ProtectedRoute } from '~/components/ProtectedRoute';

// Pages
import Home from '~/pages/Home';
import Login from '~/pages/Login';
import GoogleAuth from '~/pages/login/GoogleAuth';
import MicrosoftAuth from '~/pages/login/MicrosoftAuth';
import Logout from '~/pages/Logout';
import Session from '~/pages/session/Session';
import VibeSession from '~/pages/session/vibe/VibeSession';
import TechnicalSession from '~/pages/session/technical/TechnicalSession';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/login/authenticate/google',
    element: <GoogleAuth />
  },
  {
    path: '/login/authenticate/microsoft',
    element: <MicrosoftAuth />
  },
  {
    path: '/logout',
    element: <Logout />
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: '/session',
        element: <Session />
      },
      {
        path: '/session/vibe/:sessionId',
        element: <VibeSession />
      },
      {
        path: '/session/technical/:sessionId',
        element: <TechnicalSession />
      }
    ]
  }
]);
